import * as lpn from 'google-libphonenumber';
import * as i0 from '@angular/core';
import { Injectable, Directive, EventEmitter, forwardRef, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { setTheme } from 'ngx-bootstrap/utils';
import { BehaviorSubject } from 'rxjs';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'ngx-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import * as i6 from 'ngx-mask';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
const _c0 = ["countryList"];
const _c1 = a0 => ({
  "disabled": a0
});
function NgxIntlPhoneInputComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("+", ctx_r1.selectedCountry.dialCode, "");
  }
}
function NgxIntlPhoneInputComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "input", 18);
    i0.ɵɵtwoWayListener("ngModelChange", function NgxIntlPhoneInputComponent_div_6_div_1_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.countrySearchText, $event) || (ctx_r1.countrySearchText = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup", function NgxIntlPhoneInputComponent_div_6_div_1_Template_input_keyup_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.searchCountry());
    })("click", function NgxIntlPhoneInputComponent_div_6_div_1_Template_input_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.countrySearchText);
    i0.ɵɵproperty("placeholder", ctx_r1.searchCountryPlaceholder);
  }
}
function NgxIntlPhoneInputComponent_div_6_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 19);
    i0.ɵɵlistener("click", function NgxIntlPhoneInputComponent_div_6_li_4_Template_li_click_0_listener() {
      const country_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      const focusable_r6 = i0.ɵɵreference(8);
      return i0.ɵɵresetView(ctx_r1.onCountrySelect(country_r5, focusable_r6));
    });
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelement(2, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 23);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const country_r5 = ctx.$implicit;
    i0.ɵɵproperty("id", country_r5.htmlId + "-preferred");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", country_r5.flagClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(country_r5.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("+", country_r5.dialCode, "");
  }
}
function NgxIntlPhoneInputComponent_div_6_li_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 24);
  }
}
function NgxIntlPhoneInputComponent_div_6_li_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25);
    i0.ɵɵlistener("click", function NgxIntlPhoneInputComponent_div_6_li_6_Template_li_click_0_listener() {
      const country_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      const focusable_r6 = i0.ɵɵreference(8);
      return i0.ɵɵresetView(ctx_r1.onCountrySelect(country_r8, focusable_r6));
    });
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelement(2, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 23);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const country_r8 = ctx.$implicit;
    i0.ɵɵproperty("id", country_r8.htmlId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", country_r8.flagClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(country_r8.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("+", country_r8.dialCode, "");
  }
}
function NgxIntlPhoneInputComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, NgxIntlPhoneInputComponent_div_6_div_1_Template, 2, 2, "div", 12);
    i0.ɵɵelementStart(2, "ul", 13, 1);
    i0.ɵɵtemplate(4, NgxIntlPhoneInputComponent_div_6_li_4_Template, 7, 4, "li", 14)(5, NgxIntlPhoneInputComponent_div_6_li_5_Template, 1, 0, "li", 15)(6, NgxIntlPhoneInputComponent_div_6_li_6_Template, 7, 4, "li", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.searchCountryFlag && ctx_r1.searchCountryField);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.preferredCountriesInDropDown);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.preferredCountriesInDropDown == null ? null : ctx_r1.preferredCountriesInDropDown.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getAllCountries);
  }
}
var CountryISO = /*#__PURE__*/function (CountryISO) {
  CountryISO["Afghanistan"] = "af";
  CountryISO["Albania"] = "al";
  CountryISO["Algeria"] = "dz";
  CountryISO["AmericanSamoa"] = "as";
  CountryISO["Andorra"] = "ad";
  CountryISO["Angola"] = "ao";
  CountryISO["Anguilla"] = "ai";
  CountryISO["AntiguaAndBarbuda"] = "ag";
  CountryISO["Argentina"] = "ar";
  CountryISO["Armenia"] = "am";
  CountryISO["Aruba"] = "aw";
  CountryISO["Australia"] = "au";
  CountryISO["Austria"] = "at";
  CountryISO["Azerbaijan"] = "az";
  CountryISO["Bahamas"] = "bs";
  CountryISO["Bahrain"] = "bh";
  CountryISO["Bangladesh"] = "bd";
  CountryISO["Barbados"] = "bb";
  CountryISO["Belarus"] = "by";
  CountryISO["Belgium"] = "be";
  CountryISO["Belize"] = "bz";
  CountryISO["Benin"] = "bj";
  CountryISO["Bermuda"] = "bm";
  CountryISO["Bhutan"] = "bt";
  CountryISO["Bolivia"] = "bo";
  CountryISO["BosniaAndHerzegovina"] = "ba";
  CountryISO["Botswana"] = "bw";
  CountryISO["Brazil"] = "br";
  CountryISO["BritishIndianOceanTerritory"] = "io";
  CountryISO["BritishVirginIslands"] = "vg";
  CountryISO["Brunei"] = "bn";
  CountryISO["Bulgaria"] = "bg";
  CountryISO["BurkinaFaso"] = "bf";
  CountryISO["Burundi"] = "bi";
  CountryISO["Cambodia"] = "kh";
  CountryISO["Cameroon"] = "cm";
  CountryISO["Canada"] = "ca";
  CountryISO["CapeVerde"] = "cv";
  CountryISO["CaribbeanNetherlands"] = "bq";
  CountryISO["CaymanIslands"] = "ky";
  CountryISO["CentralAfricanRepublic"] = "cf";
  CountryISO["Chad"] = "td";
  CountryISO["Chile"] = "cl";
  CountryISO["China"] = "cn";
  CountryISO["ChristmasIsland"] = "cx";
  CountryISO["Cocos"] = "cc";
  CountryISO["Colombia"] = "co";
  CountryISO["Comoros"] = "km";
  CountryISO["CongoDRCJamhuriYaKidemokrasiaYaKongo"] = "cd";
  CountryISO["CongoRepublicCongoBrazzaville"] = "cg";
  CountryISO["CookIslands"] = "ck";
  CountryISO["CostaRica"] = "cr";
  CountryISO["C\u00F4teDIvoire"] = "ci";
  CountryISO["Croatia"] = "hr";
  CountryISO["Cuba"] = "cu";
  CountryISO["Cura\u00E7ao"] = "cw";
  CountryISO["Cyprus"] = "cy";
  CountryISO["CzechRepublic"] = "cz";
  CountryISO["Denmark"] = "dk";
  CountryISO["Djibouti"] = "dj";
  CountryISO["Dominica"] = "dm";
  CountryISO["DominicanRepublic"] = "do";
  CountryISO["Ecuador"] = "ec";
  CountryISO["Egypt"] = "eg";
  CountryISO["ElSalvador"] = "sv";
  CountryISO["EquatorialGuinea"] = "gq";
  CountryISO["Eritrea"] = "er";
  CountryISO["Estonia"] = "ee";
  CountryISO["Ethiopia"] = "et";
  CountryISO["FalklandIslands"] = "fk";
  CountryISO["FaroeIslands"] = "fo";
  CountryISO["Fiji"] = "fj";
  CountryISO["Finland"] = "fi";
  CountryISO["France"] = "fr";
  CountryISO["FrenchGuiana"] = "gf";
  CountryISO["FrenchPolynesia"] = "pf";
  CountryISO["Gabon"] = "ga";
  CountryISO["Gambia"] = "gm";
  CountryISO["Georgia"] = "ge";
  CountryISO["Germany"] = "de";
  CountryISO["Ghana"] = "gh";
  CountryISO["Gibraltar"] = "gi";
  CountryISO["Greece"] = "gr";
  CountryISO["Greenland"] = "gl";
  CountryISO["Grenada"] = "gd";
  CountryISO["Guadeloupe"] = "gp";
  CountryISO["Guam"] = "gu";
  CountryISO["Guatemala"] = "gt";
  CountryISO["Guernsey"] = "gg";
  CountryISO["Guinea"] = "gn";
  CountryISO["GuineaBissau"] = "gw";
  CountryISO["Guyana"] = "gy";
  CountryISO["Haiti"] = "ht";
  CountryISO["Honduras"] = "hn";
  CountryISO["HongKong"] = "hk";
  CountryISO["Hungary"] = "hu";
  CountryISO["Iceland"] = "is";
  CountryISO["India"] = "in";
  CountryISO["Indonesia"] = "id";
  CountryISO["Iran"] = "ir";
  CountryISO["Iraq"] = "iq";
  CountryISO["Ireland"] = "ie";
  CountryISO["IsleOfMan"] = "im";
  CountryISO["Israel"] = "il";
  CountryISO["Italy"] = "it";
  CountryISO["Jamaica"] = "jm";
  CountryISO["Japan"] = "jp";
  CountryISO["Jersey"] = "je";
  CountryISO["Jordan"] = "jo";
  CountryISO["Kazakhstan"] = "kz";
  CountryISO["Kenya"] = "ke";
  CountryISO["Kiribati"] = "ki";
  CountryISO["Kosovo"] = "xk";
  CountryISO["Kuwait"] = "kw";
  CountryISO["Kyrgyzstan"] = "kg";
  CountryISO["Laos"] = "la";
  CountryISO["Latvia"] = "lv";
  CountryISO["Lebanon"] = "lb";
  CountryISO["Lesotho"] = "ls";
  CountryISO["Liberia"] = "lr";
  CountryISO["Libya"] = "ly";
  CountryISO["Liechtenstein"] = "li";
  CountryISO["Lithuania"] = "lt";
  CountryISO["Luxembourg"] = "lu";
  CountryISO["Macau"] = "mo";
  CountryISO["Macedonia"] = "mk";
  CountryISO["Madagascar"] = "mg";
  CountryISO["Malawi"] = "mw";
  CountryISO["Malaysia"] = "my";
  CountryISO["Maldives"] = "mv";
  CountryISO["Mali"] = "ml";
  CountryISO["Malta"] = "mt";
  CountryISO["MarshallIslands"] = "mh";
  CountryISO["Martinique"] = "mq";
  CountryISO["Mauritania"] = "mr";
  CountryISO["Mauritius"] = "mu";
  CountryISO["Mayotte"] = "yt";
  CountryISO["Mexico"] = "mx";
  CountryISO["Micronesia"] = "fm";
  CountryISO["Moldova"] = "md";
  CountryISO["Monaco"] = "mc";
  CountryISO["Mongolia"] = "mn";
  CountryISO["Montenegro"] = "me";
  CountryISO["Montserrat"] = "ms";
  CountryISO["Morocco"] = "ma";
  CountryISO["Mozambique"] = "mz";
  CountryISO["Myanmar"] = "mm";
  CountryISO["Namibia"] = "na";
  CountryISO["Nauru"] = "nr";
  CountryISO["Nepal"] = "np";
  CountryISO["Netherlands"] = "nl";
  CountryISO["NewCaledonia"] = "nc";
  CountryISO["NewZealand"] = "nz";
  CountryISO["Nicaragua"] = "ni";
  CountryISO["Niger"] = "ne";
  CountryISO["Nigeria"] = "ng";
  CountryISO["Niue"] = "nu";
  CountryISO["NorfolkIsland"] = "nf";
  CountryISO["NorthKorea"] = "kp";
  CountryISO["NorthernMarianaIslands"] = "mp";
  CountryISO["Norway"] = "no";
  CountryISO["Oman"] = "om";
  CountryISO["Pakistan"] = "pk";
  CountryISO["Palau"] = "pw";
  CountryISO["Palestine"] = "ps";
  CountryISO["Panama"] = "pa";
  CountryISO["PapuaNewGuinea"] = "pg";
  CountryISO["Paraguay"] = "py";
  CountryISO["Peru"] = "pe";
  CountryISO["Philippines"] = "ph";
  CountryISO["Poland"] = "pl";
  CountryISO["Portugal"] = "pt";
  CountryISO["PuertoRico"] = "pr";
  CountryISO["Qatar"] = "qa";
  CountryISO["R\u00E9union"] = "re";
  CountryISO["Romania"] = "ro";
  CountryISO["Russia"] = "ru";
  CountryISO["Rwanda"] = "rw";
  CountryISO["SaintBarth\u00E9lemy"] = "bl";
  CountryISO["SaintHelena"] = "sh";
  CountryISO["SaintKittsAndNevis"] = "kn";
  CountryISO["SaintLucia"] = "lc";
  CountryISO["SaintMartin"] = "mf";
  CountryISO["SaintPierreAndMiquelon"] = "pm";
  CountryISO["SaintVincentAndTheGrenadines"] = "vc";
  CountryISO["Samoa"] = "ws";
  CountryISO["SanMarino"] = "sm";
  CountryISO["S\u00E3oTom\u00E9AndPr\u00EDncipe"] = "st";
  CountryISO["SaudiArabia"] = "sa";
  CountryISO["Senegal"] = "sn";
  CountryISO["Serbia"] = "rs";
  CountryISO["Seychelles"] = "sc";
  CountryISO["SierraLeone"] = "sl";
  CountryISO["Singapore"] = "sg";
  CountryISO["SintMaarten"] = "sx";
  CountryISO["Slovakia"] = "sk";
  CountryISO["Slovenia"] = "si";
  CountryISO["SolomonIslands"] = "sb";
  CountryISO["Somalia"] = "so";
  CountryISO["SouthAfrica"] = "za";
  CountryISO["SouthKorea"] = "kr";
  CountryISO["SouthSudan"] = "ss";
  CountryISO["Spain"] = "es";
  CountryISO["SriLanka"] = "lk";
  CountryISO["Sudan"] = "sd";
  CountryISO["Suriname"] = "sr";
  CountryISO["SvalbardAndJanMayen"] = "sj";
  CountryISO["Swaziland"] = "sz";
  CountryISO["Sweden"] = "se";
  CountryISO["Switzerland"] = "ch";
  CountryISO["Syria"] = "sy";
  CountryISO["Taiwan"] = "tw";
  CountryISO["Tajikistan"] = "tj";
  CountryISO["Tanzania"] = "tz";
  CountryISO["Thailand"] = "th";
  CountryISO["TimorLeste"] = "tl";
  CountryISO["Togo"] = "tg";
  CountryISO["Tokelau"] = "tk";
  CountryISO["Tonga"] = "to";
  CountryISO["TrinidadAndTobago"] = "tt";
  CountryISO["Tunisia"] = "tn";
  CountryISO["Turkey"] = "tr";
  CountryISO["Turkmenistan"] = "tm";
  CountryISO["TurksAndCaicosIslands"] = "tc";
  CountryISO["Tuvalu"] = "tv";
  CountryISO["USVirginIslands"] = "vi";
  CountryISO["Uganda"] = "ug";
  CountryISO["Ukraine"] = "ua";
  CountryISO["UnitedArabEmirates"] = "ae";
  CountryISO["UnitedKingdom"] = "gb";
  CountryISO["UnitedStates"] = "us";
  CountryISO["Uruguay"] = "uy";
  CountryISO["Uzbekistan"] = "uz";
  CountryISO["Vanuatu"] = "vu";
  CountryISO["VaticanCity"] = "va";
  CountryISO["Venezuela"] = "ve";
  CountryISO["Vietnam"] = "vn";
  CountryISO["WallisAndFutuna"] = "wf";
  CountryISO["WesternSahara"] = "eh";
  CountryISO["Yemen"] = "ye";
  CountryISO["Zambia"] = "zm";
  CountryISO["Zimbabwe"] = "zw";
  CountryISO["\u00C5landIslands"] = "ax";
  return CountryISO;
}(CountryISO || {});
let CountryCode = /*#__PURE__*/(() => {
  class CountryCode {
    constructor() {
      this.allCountries = {
        en: [['Afghanistan (‫افغانستان‬‎)', CountryISO.Afghanistan, '93'], ['Albania (Shqipëri)', CountryISO.Albania, '355'], ['Algeria (‫الجزائر‬‎)', CountryISO.Algeria, '213'], ['American Samoa', 'as', '1', 1, ['684']], ['Andorra', CountryISO.Andorra, '376'], ['Angola', CountryISO.Angola, '244'], ['Anguilla', 'ai', '1', 1, ['264']], ['Antigua and Barbuda', 'ag', '1', 1, ['268']], ['Argentina', CountryISO.Argentina, '54'], ['Armenia (Հայաստան)', CountryISO.Armenia, '374'], ['Aruba', CountryISO.Aruba, '297'], ['Australia', CountryISO.Australia, '61', 0], ['Austria (Österreich)', CountryISO.Austria, '43'], ['Azerbaijan (Azərbaycan)', CountryISO.Azerbaijan, '994'], ['Bahamas', 'bs', '1', 1, ['242']], ['Bahrain (‫البحرين‬‎)', CountryISO.Bahrain, '973'], ['Bangladesh (বাংলাদেশ)', CountryISO.Bangladesh, '880'], ['Barbados', 'bb', '1', 1, ['246']], ['Belarus (Беларусь)', CountryISO.Belarus, '375'], ['Belgium (België)', CountryISO.Belgium, '32'], ['Belize', CountryISO.Belize, '501'], ['Benin (Bénin)', CountryISO.Benin, '229'], ['Bermuda', 'bm', '1', 1, ['441']], ['Bhutan (འབྲུག)', CountryISO.Bhutan, '975'], ['Bolivia', CountryISO.Bolivia, '591'], ['Bosnia and Herzegovina (Босна и Херцеговина)', CountryISO.BosniaAndHerzegovina, '387'], ['Botswana', CountryISO.Botswana, '267'], ['Brazil (Brasil)', CountryISO.Brazil, '55'], ['British Indian Ocean Territory', CountryISO.BritishIndianOceanTerritory, '246'], ['British Virgin Islands', 'vg', '1', 1, ['284']], ['Brunei', CountryISO.Brunei, '673'], ['Bulgaria (България)', CountryISO.Bulgaria, '359'], ['Burkina Faso', CountryISO.BurkinaFaso, '226'], ['Burundi (Uburundi)', CountryISO.Burundi, '257'], ['Cambodia (កម្ពុជា)', CountryISO.Cambodia, '855'], ['Cameroon (Cameroun)', CountryISO.Cameroon, '237'], ['Canada', CountryISO.Canada, '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Cape Verde (Kabu Verdi)', CountryISO.CapeVerde, '238'], ['Caribbean Netherlands', CountryISO.CaribbeanNetherlands, '599', 1], ['Cayman Islands', 'ky', '1', 1, ['345']], ['Central African Republic (République centrafricaine)', CountryISO.CentralAfricanRepublic, '236'], ['Chad (Tchad)', CountryISO.Chad, '235'], ['Chile', CountryISO.Chile, '56'], ['China (中国)', CountryISO.China, '86'], ['Christmas Island', CountryISO.ChristmasIsland, '61', 2], ['Cocos (Keeling) Islands', CountryISO.Cocos, '61', 1], ['Colombia', CountryISO.Colombia, '57'], ['Comoros (‫جزر القمر‬‎)', CountryISO.Comoros, '269'], ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo, '243'], ['Congo (Republic) (Congo-Brazzaville)', CountryISO.CongoRepublicCongoBrazzaville, '242'], ['Cook Islands', CountryISO.CookIslands, '682'], ['Costa Rica', CountryISO.CostaRica, '506'], ['Côte d’Ivoire', CountryISO.CôteDIvoire, '225'], ['Croatia (Hrvatska)', CountryISO.Croatia, '385'], ['Cuba', CountryISO.Cuba, '53'], ['Curaçao', CountryISO.Curaçao, '599', 0], ['Cyprus (Κύπρος)', CountryISO.Cyprus, '357'], ['Czech Republic (Česká republika)', CountryISO.CzechRepublic, '420'], ['Denmark (Danmark)', CountryISO.Denmark, '45'], ['Djibouti', CountryISO.Djibouti, '253'], ['Dominica', CountryISO.Dominica, '1767'], ['Dominican Republic (República Dominicana)', CountryISO.DominicanRepublic, '1', 2, ['809', '829', '849']], ['Ecuador', CountryISO.Ecuador, '593'], ['Egypt (‫مصر‬‎)', CountryISO.Egypt, '20'], ['El Salvador', CountryISO.ElSalvador, '503'], ['Equatorial Guinea (Guinea Ecuatorial)', CountryISO.EquatorialGuinea, '240'], ['Eritrea', CountryISO.Eritrea, '291'], ['Estonia (Eesti)', CountryISO.Estonia, '372'], ['Ethiopia', CountryISO.Ethiopia, '251'], ['Falkland Islands (Islas Malvinas)', CountryISO.FalklandIslands, '500'], ['Faroe Islands (Føroyar)', CountryISO.FaroeIslands, '298'], ['Fiji', CountryISO.Fiji, '679'], ['Finland (Suomi)', CountryISO.Finland, '358', 0], ['France', CountryISO.France, '33'], ['French Guiana (Guyane française)', CountryISO.FrenchGuiana, '594'], ['French Polynesia (Polynésie française)', CountryISO.FrenchPolynesia, '689'], ['Gabon', CountryISO.Gabon, '241'], ['Gambia', CountryISO.Gambia, '220'], ['Georgia (საქართველო)', CountryISO.Georgia, '995'], ['Germany (Deutschland)', CountryISO.Germany, '49'], ['Ghana (Gaana)', CountryISO.Ghana, '233'], ['Gibraltar', CountryISO.Gibraltar, '350'], ['Greece (Ελλάδα)', CountryISO.Greece, '30'], ['Greenland (Kalaallit Nunaat)', CountryISO.Greenland, '299'], ['Grenada', CountryISO.Grenada, '1473'], ['Guadeloupe', CountryISO.Guadeloupe, '590', 0], ['Guam', 'gu', '1', 1, ['671']], ['Guatemala', CountryISO.Guatemala, '502'], ['Guernsey', CountryISO.Guernsey, '44', 1, [1481]], ['Guinea (Guinée)', CountryISO.Guinea, '224'], ['Guinea-Bissau (Guiné Bissau)', CountryISO.GuineaBissau, '245'], ['Guyana', CountryISO.Guyana, '592'], ['Haiti', CountryISO.Haiti, '509'], ['Honduras', CountryISO.Honduras, '504'], ['Hong Kong (香港)', CountryISO.HongKong, '852'], ['Hungary (Magyarország)', CountryISO.Hungary, '36'], ['Iceland (Ísland)', CountryISO.Iceland, '354'], ['India (भारत)', CountryISO.India, '91'], ['Indonesia', CountryISO.Indonesia, '62'], ['Iran (‫ایران‬‎)', CountryISO.Iran, '98'], ['Iraq (‫العراق‬‎)', CountryISO.Iraq, '964'], ['Ireland', CountryISO.Ireland, '353'], ['Isle of Man', CountryISO.IsleOfMan, '44', 2, [1624]], ['Israel (‫ישראל‬‎)', CountryISO.Israel, '972'], ['Italy (Italia)', CountryISO.Italy, '39', 0], ['Jamaica', 'jm', '1', 1, ['876']], ['Japan (日本)', CountryISO.Japan, '81'], ['Jersey', CountryISO.Jersey, '44', 3, [1534]], ['Jordan (‫الأردن‬‎)', CountryISO.Jordan, '962'], ['Kenya', CountryISO.Kenya, '254'], ['Kiribati', CountryISO.Kiribati, '686'], ['Kosovo', CountryISO.Kosovo, '383'], ['Kuwait (‫الكويت‬‎)', CountryISO.Kuwait, '965'], ['Kyrgyzstan (Кыргызстан)', CountryISO.Kyrgyzstan, '996'], ['Laos (ລາວ)', CountryISO.Laos, '856'], ['Latvia (Latvija)', CountryISO.Latvia, '371'], ['Lebanon (‫لبنان‬‎)', CountryISO.Lebanon, '961'], ['Lesotho', CountryISO.Lesotho, '266'], ['Liberia', CountryISO.Liberia, '231'], ['Libya (‫ليبيا‬‎)', CountryISO.Libya, '218'], ['Liechtenstein', CountryISO.Liechtenstein, '423'], ['Lithuania (Lietuva)', CountryISO.Lithuania, '370'], ['Luxembourg', CountryISO.Luxembourg, '352'], ['Macau (澳門)', CountryISO.Macau, '853'], ['Macedonia (FYROM) (Македонија)', CountryISO.Macedonia, '389'], ['Madagascar (Madagasikara)', CountryISO.Madagascar, '261'], ['Malawi', CountryISO.Malawi, '265'], ['Malaysia', CountryISO.Malaysia, '60'], ['Maldives', CountryISO.Maldives, '960'], ['Mali', CountryISO.Mali, '223'], ['Malta', CountryISO.Malta, '356'], ['Marshall Islands', CountryISO.MarshallIslands, '692'], ['Martinique', CountryISO.Martinique, '596'], ['Mauritania (‫موريتانيا‬‎)', CountryISO.Mauritania, '222'], ['Mauritius (Moris)', CountryISO.Mauritius, '230'], ['Mayotte', CountryISO.Mayotte, '262', 1], ['Mexico (México)', CountryISO.Mexico, '52'], ['Micronesia', CountryISO.Micronesia, '691'], ['Moldova (Republica Moldova)', CountryISO.Moldova, '373'], ['Monaco', CountryISO.Monaco, '377'], ['Mongolia (Монгол)', CountryISO.Mongolia, '976'], ['Montenegro (Crna Gora)', CountryISO.Montenegro, '382'], ['Montserrat', 'ms', '1', 1, ['664']], ['Morocco (‫المغرب‬‎)', CountryISO.Morocco, '212', 0], ['Mozambique (Moçambique)', CountryISO.Mozambique, '258'], ['Myanmar (Burma) (မြန်မာ)', CountryISO.Myanmar, '95'], ['Namibia (Namibië)', CountryISO.Namibia, '264'], ['Nauru', CountryISO.Nauru, '674'], ['Nepal (नेपाल)', CountryISO.Nepal, '977'], ['Netherlands (Nederland)', CountryISO.Netherlands, '31'], ['New Caledonia (Nouvelle-Calédonie)', CountryISO.NewCaledonia, '687'], ['New Zealand', CountryISO.NewZealand, '64'], ['Nicaragua', CountryISO.Nicaragua, '505'], ['Niger (Nijar)', CountryISO.Niger, '227'], ['Nigeria', CountryISO.Nigeria, '234'], ['Niue', CountryISO.Niue, '683'], ['Norfolk Island', CountryISO.NorfolkIsland, '672'], ['North Korea (조선 민주주의 인민 공화국)', CountryISO.NorthKorea, '850'], ['Northern Mariana Islands', CountryISO.NorthernMarianaIslands, '1670'], ['Norway (Norge)', CountryISO.Norway, '47', 0], ['Oman (‫عُمان‬‎)', CountryISO.Oman, '968'], ['Pakistan (‫پاکستان‬‎)', CountryISO.Pakistan, '92'], ['Palau', CountryISO.Palau, '680'], ['Palestine (‫فلسطين‬‎)', CountryISO.Palestine, '970'], ['Panama (Panamá)', CountryISO.Panama, '507'], ['Papua New Guinea', CountryISO.PapuaNewGuinea, '675'], ['Paraguay', CountryISO.Paraguay, '595'], ['Peru (Perú)', CountryISO.Peru, '51'], ['Philippines', CountryISO.Philippines, '63'], ['Poland (Polska)', CountryISO.Poland, '48'], ['Portugal', CountryISO.Portugal, '351'], ['Puerto Rico', CountryISO.PuertoRico, '1', 3, ['787', '939']], ['Qatar (‫قطر‬‎)', CountryISO.Qatar, '974'], ['Réunion (La Réunion)', CountryISO.Réunion, '262', 0], ['Romania (România)', CountryISO.Romania, '40'], ['Russia (Россия)', CountryISO.Russia, '7', 0, ['900', '901', '902', '903', '904', '905', '906', '908', '909', '910', '911', '912', '913', '914', '915', '916', '917', '918', '919', '920', '921', '922', '923', '924', '925', '926', '927', '928', '929', '930', '931', '932', '933', '934', '936', '937', '938', '939', '941', '942', '949', '950', '951', '952', '953', '954', '955', '956', '958', '959', '960', '961', '962', '963', '964', '965', '966', '967', '968', '969', '970', '971', '977', '978', '979', '980', '981', '982', '983', '984', '985', '986', '987', '988', '989', '990', '991', '992', '993', '994', '995', '996', '997', '999']], ['Kazakhstan (Казахстан)', CountryISO.Kazakhstan, '7', 1], ['Rwanda', CountryISO.Rwanda, '250'], ['Saint Barthélemy (Saint-Barthélemy)', CountryISO.SaintBarthélemy, '590', 1], ['Saint Helena', CountryISO.SaintHelena, '290'], ['Saint Kitts and Nevis', CountryISO.SaintKittsAndNevis, '1869'], ['Saint Lucia', 'lc', '1', 1, ['758']], ['Saint Martin (Saint-Martin (partie française))', CountryISO.SaintMartin, '590', 2], ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', CountryISO.SaintPierreAndMiquelon, '508'], ['Saint Vincent and the Grenadines', 'vc', '1', 1, ['784']], ['Samoa', CountryISO.Samoa, '685'], ['San Marino', CountryISO.SanMarino, '378'], ['São Tomé and Príncipe (São Tomé e Príncipe)', CountryISO.SãoToméAndPríncipe, '239'], ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', CountryISO.SaudiArabia, '966'], ['Senegal (Sénégal)', CountryISO.Senegal, '221'], ['Serbia (Србија)', CountryISO.Serbia, '381'], ['Seychelles', CountryISO.Seychelles, '248'], ['Sierra Leone', CountryISO.SierraLeone, '232'], ['Singapore', CountryISO.Singapore, '65'], ['Sint Maarten', 'sx', '1', 1, ['721']], ['Slovakia (Slovensko)', CountryISO.Slovakia, '421'], ['Slovenia (Slovenija)', CountryISO.Slovenia, '386'], ['Solomon Islands', CountryISO.SolomonIslands, '677'], ['Somalia (Soomaaliya)', CountryISO.Somalia, '252'], ['South Africa', CountryISO.SouthAfrica, '27'], ['South Korea (대한민국)', CountryISO.SouthKorea, '82'], ['South Sudan (‫جنوب السودان‬‎)', CountryISO.SouthSudan, '211'], ['Spain (España)', CountryISO.Spain, '34'], ['Sri Lanka (ශ්‍රී ලංකාව)', CountryISO.SriLanka, '94'], ['Sudan (‫السودان‬‎)', CountryISO.Sudan, '249'], ['Suriname', CountryISO.Suriname, '597'], ['Svalbard and Jan Mayen', CountryISO.SvalbardAndJanMayen, '47', 1], ['Swaziland', CountryISO.Swaziland, '268'], ['Sweden (Sverige)', CountryISO.Sweden, '46'], ['Switzerland (Schweiz)', CountryISO.Switzerland, '41'], ['Syria (‫سوريا‬‎)', CountryISO.Syria, '963'], ['Taiwan (台灣)', CountryISO.Taiwan, '886'], ['Tajikistan', CountryISO.Tajikistan, '992'], ['Tanzania', CountryISO.Tanzania, '255'], ['Thailand (ไทย)', CountryISO.Thailand, '66'], ['Timor-Leste', CountryISO.TimorLeste, '670'], ['Togo', CountryISO.Togo, '228'], ['Tokelau', CountryISO.Tokelau, '690'], ['Tonga', CountryISO.Tonga, '676'], ['Trinidad and Tobago', 'tt', '1', 1, ['868']], ['Tunisia (‫تونس‬‎)', CountryISO.Tunisia, '216'], ['Turkey (Türkiye)', CountryISO.Turkey, '90'], ['Turkmenistan', CountryISO.Turkmenistan, '993'], ['Turks and Caicos Islands', CountryISO.TurksAndCaicosIslands, '1649'], ['Tuvalu', CountryISO.Tuvalu, '688'], ['U.S. Virgin Islands', 'vi', '1', 1, ['340']], ['Uganda', CountryISO.Uganda, '256'], ['Ukraine (Україна)', CountryISO.Ukraine, '380'], ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', CountryISO.UnitedArabEmirates, '971'], ['United Kingdom', CountryISO.UnitedKingdom, '44', 0], ['United States', CountryISO.UnitedStates, '1', 0], ['Uruguay', CountryISO.Uruguay, '598'], ['Uzbekistan (Oʻzbekiston)', CountryISO.Uzbekistan, '998'], ['Vanuatu', CountryISO.Vanuatu, '678'], ['Vatican City (Città del Vaticano)', CountryISO.VaticanCity, '39', 1], ['Venezuela', CountryISO.Venezuela, '58'], ['Vietnam (Việt Nam)', CountryISO.Vietnam, '84'], ['Wallis and Futuna', CountryISO.WallisAndFutuna, '681'], ['Western Sahara (‫الصحراء الغربية‬‎)', CountryISO.WesternSahara, '212', 1], ['Yemen (‫اليمن‬‎)', CountryISO.Yemen, '967'], ['Zambia', CountryISO.Zambia, '260'], ['Zimbabwe', CountryISO.Zimbabwe, '263'], ['Åland Islands', CountryISO.ÅlandIslands, '358', 1]],
        ru: [['Афганистан (‫افغانستان‬‎)', CountryISO.Afghanistan, '93'], ['Албания (Shqipëri)', CountryISO.Albania, '355'], ['Алжир (‫الجزائر‬‎)', CountryISO.Algeria, '213'], ['Американское Самоа', 'as', '1', 1, ['684']], ['Андорра', CountryISO.Andorra, '376'], ['Ангола', CountryISO.Angola, '244'], ['Ангилья', 'ai', '1', 1, ['264']], ['Антигуа и Барбуда', 'ag', '1', 1, ['268']], ['Аргентина', CountryISO.Argentina, '54'], ['Армения (Հայաստան)', CountryISO.Armenia, '374'], ['Аруба', CountryISO.Aruba, '297'], ['Австралия', CountryISO.Australia, '61', 0], ['Австрия (Österreich)', CountryISO.Austria, '43'], ['Азербайджан (Azərbaycan)', CountryISO.Azerbaijan, '994'], ['Багамы', 'bs', '1', 1, ['242']], ['Бахрейн (‫البحرين‬‎)', CountryISO.Bahrain, '973'], ['Бангладеш (বাংলাদেশ)', CountryISO.Bangladesh, '880'], ['Барбадос', 'bb', '1', 1, ['246']], ['Беларусь (Беларусь)', CountryISO.Belarus, '375'], ['Бельгия (België)', CountryISO.Belgium, '32'], ['Белиз', CountryISO.Belize, '501'], ['Бенин (Bénin)', CountryISO.Benin, '229'], ['Бермуды', 'bm', '1', 1, ['441']], ['Бутан (འབྲུག)', CountryISO.Bhutan, '975'], ['Боливия', CountryISO.Bolivia, '591'], ['Босния и Герцеговина (Босна и Херцеговина)', CountryISO.BosniaAndHerzegovina, '387'], ['Ботсвана', CountryISO.Botswana, '267'], ['Бразилия (Brasil)', CountryISO.Brazil, '55'], ['Британская территория в Индийском океане', CountryISO.BritishIndianOceanTerritory, '246'], ['Британские Виргинские острова', 'vg', '1', 1, ['284']], ['Бруней', CountryISO.Brunei, '673'], ['Болгария (България)', CountryISO.Bulgaria, '359'], ['Буркино фасо', CountryISO.BurkinaFaso, '226'], ['Бурунди (Uburundi)', CountryISO.Burundi, '257'], ['Камбоджа (កម្ពុជា)', CountryISO.Cambodia, '855'], ['Камерун (Cameroun)', CountryISO.Cameroon, '237'], ['Канада', CountryISO.Canada, '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Кабо-верде (Kabu Verdi)', CountryISO.CapeVerde, '238'], ['Бонэйр', CountryISO.CaribbeanNetherlands, '599', 1], ['Острова Кайман', 'ky', '1', 1, ['345']], ['Центральноафриканская Республика (République centrafricaine)', CountryISO.CentralAfricanRepublic, '236'], ['Чад (Tchad)', CountryISO.Chad, '235'], ['Чили', CountryISO.Chile, '56'], ['Китай (中国)', CountryISO.China, '86'], ['Остров Рождества', CountryISO.ChristmasIsland, '61', 2], ['Кокосовые острова', CountryISO.Cocos, '61', 1], ['Колумбия', CountryISO.Colombia, '57'], ['Коморы (‫جزر القمر‬‎)', CountryISO.Comoros, '269'], ['Конго (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo, '243'], ['Конго (Republic) (Congo-Brazzaville)', CountryISO.CongoRepublicCongoBrazzaville, '242'], ['Острова Кука', CountryISO.CookIslands, '682'], ['Коста Рика', CountryISO.CostaRica, '506'], ['Кот-д`Ивуар', CountryISO.CôteDIvoire, '225'], ['Хорватия (Hrvatska)', CountryISO.Croatia, '385'], ['Куба', CountryISO.Cuba, '53'], ['Кюрасао', CountryISO.Curaçao, '599', 0], ['Кипр (Κύπρος)', CountryISO.Cyprus, '357'], ['Чехия (Česká republika)', CountryISO.CzechRepublic, '420'], ['Дания (Danmark)', CountryISO.Denmark, '45'], ['Джибути', CountryISO.Djibouti, '253'], ['Доминикана', CountryISO.Dominica, '1767'], ['Доминиканская Республика (República Dominicana)', CountryISO.DominicanRepublic, '1', 2, ['809', '829', '849']], ['Эквадор', CountryISO.Ecuador, '593'], ['Египет (‫مصر‬‎)', CountryISO.Egypt, '20'], ['Сальвадор', CountryISO.ElSalvador, '503'], ['Экваториальная Гвинея (Guinea Ecuatorial)', CountryISO.EquatorialGuinea, '240'], ['Эритрея', CountryISO.Eritrea, '291'], ['Эстония (Eesti)', CountryISO.Estonia, '372'], ['Эфиопия', CountryISO.Ethiopia, '251'], ['Фолклендские острова (Islas Malvinas)', CountryISO.FalklandIslands, '500'], ['Фарерские острова (Føroyar)', CountryISO.FaroeIslands, '298'], ['Фиджи', CountryISO.Fiji, '679'], ['Финляндия (Suomi)', CountryISO.Finland, '358', 0], ['Франция', CountryISO.France, '33'], ['Французская Гвиана (Guyane française)', CountryISO.FrenchGuiana, '594'], ['Французская Полинезия (Polynésie française)', CountryISO.FrenchPolynesia, '689'], ['Габон', CountryISO.Gabon, '241'], ['Гамбия', CountryISO.Gambia, '220'], ['Грузия (საქართველო)', CountryISO.Georgia, '995'], ['Германия (Deutschland)', CountryISO.Germany, '49'], ['Гана (Gaana)', CountryISO.Ghana, '233'], ['Гибралтар', CountryISO.Gibraltar, '350'], ['Греция (Ελλάδα)', CountryISO.Greece, '30'], ['Гринландия (Kalaallit Nunaat)', CountryISO.Greenland, '299'], ['Гренада', CountryISO.Grenada, '1473'], ['Гваделупа', CountryISO.Guadeloupe, '590', 0], ['Гуам', 'gu', '1', 1, ['671']], ['Гватемала', CountryISO.Guatemala, '502'], ['Гернси', CountryISO.Guernsey, '44', 1, [1481]], ['Гвинея (Guinée)', CountryISO.Guinea, '224'], ['Гвинея-Биссау (Guiné Bissau)', CountryISO.GuineaBissau, '245'], ['Гайяна', CountryISO.Guyana, '592'], ['Гаити', CountryISO.Haiti, '509'], ['Гондурас', CountryISO.Honduras, '504'], ['Гонконг (香港)', CountryISO.HongKong, '852'], ['Венгрия (Magyarország)', CountryISO.Hungary, '36'], ['Исландия (Ísland)', CountryISO.Iceland, '354'], ['Индия (भारत)', CountryISO.India, '91'], ['Индонезия', CountryISO.Indonesia, '62'], ['Иран (‫ایران‬‎)', CountryISO.Iran, '98'], ['Ирак (‫العراق‬‎)', CountryISO.Iraq, '964'], ['Ирландия', CountryISO.Ireland, '353'], ['Остров Мэн', CountryISO.IsleOfMan, '44', 2, [1624]], ['Израиль (‫ישראל‬‎)', CountryISO.Israel, '972'], ['Италия (Italia)', CountryISO.Italy, '39', 0], ['Ямайка', 'jm', '1', 1, ['876']], ['Япония (日本)', CountryISO.Japan, '81'], ['Джерси', CountryISO.Jersey, '44', 3, [1534]], ['Джордан (‫الأردن‬‎)', CountryISO.Jordan, '962'], ['Кения', CountryISO.Kenya, '254'], ['Кирибати', CountryISO.Kiribati, '686'], ['Косово', CountryISO.Kosovo, '383'], ['Кувейт (‫الكويت‬‎)', CountryISO.Kuwait, '965'], ['Кыргызстан (Кыргызстан)', CountryISO.Kyrgyzstan, '996'], ['Лаос (ລາວ)', CountryISO.Laos, '856'], ['Латвия (Latvija)', CountryISO.Latvia, '371'], ['Ливан (‫لبنان‬‎)', CountryISO.Lebanon, '961'], ['Лесото', CountryISO.Lesotho, '266'], ['Либерия', CountryISO.Liberia, '231'], ['Ливия (‫ليبيا‬‎)', CountryISO.Libya, '218'], ['Лихтенштейн', CountryISO.Liechtenstein, '423'], ['Литва (Lietuva)', CountryISO.Lithuania, '370'], ['Люксембург', CountryISO.Luxembourg, '352'], ['Макао (澳門)', CountryISO.Macau, '853'], ['Македония (FYROM) (Македонија)', CountryISO.Macedonia, '389'], ['Мадагасккар (Madagasikara)', CountryISO.Madagascar, '261'], ['Малави', CountryISO.Malawi, '265'], ['Малайзия', CountryISO.Malaysia, '60'], ['Мальдивы', CountryISO.Maldives, '960'], ['Мали', CountryISO.Mali, '223'], ['Мальта', CountryISO.Malta, '356'], ['Маршалловы острова', CountryISO.MarshallIslands, '692'], ['Мартиника', CountryISO.Martinique, '596'], ['Мавритания (‫موريتانيا‬‎)', CountryISO.Mauritania, '222'], ['Маврикий (Moris)', CountryISO.Mauritius, '230'], ['Майотта', CountryISO.Mayotte, '262', 1], ['Мексика (México)', CountryISO.Mexico, '52'], ['Микронезия', CountryISO.Micronesia, '691'], ['Молдова (Republica Moldova)', CountryISO.Moldova, '373'], ['Монако', CountryISO.Monaco, '377'], ['Монголия (Монгол)', CountryISO.Mongolia, '976'], ['Монтенегро (Crna Gora)', CountryISO.Montenegro, '382'], ['Монтсеррат', 'ms', '1', 1, ['664']], ['Марокко (‫المغرب‬‎)', CountryISO.Morocco, '212', 0], ['Мозамбик (Moçambique)', CountryISO.Mozambique, '258'], ['Мьянма (Burma) (မြန်မာ)', CountryISO.Myanmar, '95'], ['Намибия (Namibië)', CountryISO.Namibia, '264'], ['Науру', CountryISO.Nauru, '674'], ['Непал (नेपाल)', CountryISO.Nepal, '977'], ['Нидерланды (Nederland)', CountryISO.Netherlands, '31'], ['Новая Каледония (Nouvelle-Calédonie)', CountryISO.NewCaledonia, '687'], ['Новая Зеландия', CountryISO.NewZealand, '64'], ['Никарагуа', CountryISO.Nicaragua, '505'], ['Нигер (Nijar)', CountryISO.Niger, '227'], ['Нигерия', CountryISO.Nigeria, '234'], ['Ниуэ', CountryISO.Niue, '683'], ['Остров Норфолк', CountryISO.NorfolkIsland, '672'], ['Северная Корея (조선 민주주의 인민 공화국)', CountryISO.NorthKorea, '850'], ['Северные Марианские острова', CountryISO.NorthernMarianaIslands, '1670'], ['Норвегия (Norge)', CountryISO.Norway, '47', 0], ['Оман (‫عُمان‬‎)', CountryISO.Oman, '968'], ['Пакистан (‫پاکستان‬‎)', CountryISO.Pakistan, '92'], ['Палау', CountryISO.Palau, '680'], ['Палестина (‫فلسطين‬‎)', CountryISO.Palestine, '970'], ['Панама (Panamá)', CountryISO.Panama, '507'], ['Папуа Новая Гвинея', CountryISO.PapuaNewGuinea, '675'], ['Парагвай', CountryISO.Paraguay, '595'], ['Перу (Perú)', CountryISO.Peru, '51'], ['Филиппины', CountryISO.Philippines, '63'], ['Польша (Polska)', CountryISO.Poland, '48'], ['Португалия', CountryISO.Portugal, '351'], ['Пуэрто Рико', CountryISO.PuertoRico, '1', 3, ['787', '939']], ['Катар (‫قطر‬‎)', CountryISO.Qatar, '974'], ['Реюньон (La Réunion)', CountryISO.Réunion, '262', 0], ['Румыния (România)', CountryISO.Romania, '40'], ['Россия', CountryISO.Russia, '7', 0, ['900', '901', '902', '903', '904', '905', '906', '908', '909', '910', '911', '912', '913', '914', '915', '916', '917', '918', '919', '920', '921', '922', '923', '924', '925', '926', '927', '928', '929', '930', '931', '932', '933', '934', '936', '937', '938', '939', '941', '942', '949', '950', '951', '952', '953', '954', '955', '956', '958', '959', '960', '961', '962', '963', '964', '965', '966', '967', '968', '969', '970', '971', '977', '978', '979', '980', '981', '982', '983', '984', '985', '986', '987', '988', '989', '990', '991', '992', '993', '994', '995', '996', '997', '999']], ['Казахстан', CountryISO.Kazakhstan, '7', 1], ['Руанда', CountryISO.Rwanda, '250'], ['Сен-Бартелеми (Saint-Barthélemy)', CountryISO.SaintBarthélemy, '590', 1], ['остров Святой Елены', CountryISO.SaintHelena, '290'], ['Сент-Китс и Невис', CountryISO.SaintKittsAndNevis, '1869'], ['Saint Lucia', 'lc', '1', 1, ['758']], ['Сен-Мартен (Saint-Martin (partie française))', CountryISO.SaintMartin, '590', 2], ['Сен-Пьер и Микелон (Saint-Pierre-et-Miquelon)', CountryISO.SaintPierreAndMiquelon, '508'], ['Сент-Винсент и Гренадины', 'vc', '1', 1, ['784']], ['Самоа', CountryISO.Samoa, '685'], ['Сан-Марино', CountryISO.SanMarino, '378'], ['Сан-Томе и Принсипи (São Tomé e Príncipe)', CountryISO.SãoToméAndPríncipe, '239'], ['Саудовская Аравия (‫المملكة العربية السعودية‬‎)', CountryISO.SaudiArabia, '966'], ['Сенегал (Sénégal)', CountryISO.Senegal, '221'], ['Сербия (Србија)', CountryISO.Serbia, '381'], ['Сейшелы', CountryISO.Seychelles, '248'], ['Сьерра-Леоне', CountryISO.SierraLeone, '232'], ['Сингапур', CountryISO.Singapore, '65'], ['Синт-Мартен', 'sx', '1', 1, ['721']], ['Словакия (Slovensko)', CountryISO.Slovakia, '421'], ['Словения (Slovenija)', CountryISO.Slovenia, '386'], ['Соломоновы острова', CountryISO.SolomonIslands, '677'], ['Сомали (Soomaaliya)', CountryISO.Somalia, '252'], ['Южная Африка', CountryISO.SouthAfrica, '27'], ['Южная Корея (대한민국)', CountryISO.SouthKorea, '82'], ['Южный Судан (‫جنوب السودان‬‎)', CountryISO.SouthSudan, '211'], ['Испания (España)', CountryISO.Spain, '34'], ['Шри-Ланка (ශ්‍රී ලංකාව)', CountryISO.SriLanka, '94'], ['Судан (‫السودان‬‎)', CountryISO.Sudan, '249'], ['Суринам', CountryISO.Suriname, '597'], ['Шпицберген и Ян-Майен', CountryISO.SvalbardAndJanMayen, '47', 1], ['Эсватини', CountryISO.Swaziland, '268'], ['Швеция (Sverige)', CountryISO.Sweden, '46'], ['Швейцария (Schweiz)', CountryISO.Switzerland, '41'], ['Сирия (‫سوريا‬‎)', CountryISO.Syria, '963'], ['Тайвань (台灣)', CountryISO.Taiwan, '886'], ['Таджикистан', CountryISO.Tajikistan, '992'], ['Танзания', CountryISO.Tanzania, '255'], ['Тайланд (ไทย)', CountryISO.Thailand, '66'], ['Восточный Тимор', CountryISO.TimorLeste, '670'], ['Того', CountryISO.Togo, '228'], ['Токелау', CountryISO.Tokelau, '690'], ['Тонга', CountryISO.Tonga, '676'], ['Тринидад и Тобаго', 'tt', '1', 1, ['868']], ['Тунис (‫تونس‬‎)', CountryISO.Tunisia, '216'], ['Турция (Türkiye)', CountryISO.Turkey, '90'], ['Туркменистан', CountryISO.Turkmenistan, '993'], ['Острова Теркс и Кайкос', CountryISO.TurksAndCaicosIslands, '1649'], ['Тувалу', CountryISO.Tuvalu, '688'], ['Американские Виргинские острова', 'vi', '1', 1, ['340']], ['Уганда', CountryISO.Uganda, '256'], ['Украина (Україна)', CountryISO.Ukraine, '380'], ['Объединенные Арабские Эмираты (‫الإمارات العربية المتحدة‬‎)', CountryISO.UnitedArabEmirates, '971'], ['Великобритания', CountryISO.UnitedKingdom, '44', 0], ['США', CountryISO.UnitedStates, '1', 0], ['Uruguay', CountryISO.Uruguay, '598'], ['Узбекистан (Oʻzbekiston)', CountryISO.Uzbekistan, '998'], ['Вануату', CountryISO.Vanuatu, '678'], ['Ватикан (Città del Vaticano)', CountryISO.VaticanCity, '39', 1], ['Венесуэла', CountryISO.Venezuela, '58'], ['Вьетнам (Việt Nam)', CountryISO.Vietnam, '84'], ['Уоллис и Футуна', CountryISO.WallisAndFutuna, '681'], ['Западная Сахара (‫الصحراء الغربية‬‎)', CountryISO.WesternSahara, '212', 1], ['Йемен (‫اليمن‬‎)', CountryISO.Yemen, '967'], ['Замбия', CountryISO.Zambia, '260'], ['Зимбабве', CountryISO.Zimbabwe, '263'], ['Аландские острова', CountryISO.ÅlandIslands, '358', 1]]
      };
    }
    static {
      this.ɵfac = function CountryCode_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CountryCode)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CountryCode,
        factory: CountryCode.ɵfac
      });
    }
  }
  return CountryCode;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CountryPhoneMask = /*#__PURE__*/(() => {
  class CountryPhoneMask {
    constructor() {
      this.countryPhoneMask = [{
        code: 'AC',
        mask: '000-0000'
      }, {
        code: 'AD',
        mask: '000-000-000'
      }, {
        code: 'AE',
        mask: '000-00-000-0000'
      }, {
        code: 'AE',
        mask: '000-0-000-0000'
      }, {
        code: 'AF',
        mask: '00-00-000-0000'
      }, {
        code: 'AG',
        mask: '0(000)000-0000'
      }, {
        code: 'AI',
        mask: '0(000)000-0000'
      }, {
        code: 'AL',
        mask: '000(000)000-000'
      }, {
        code: 'AM',
        mask: '000-00-000-000'
      }, {
        code: 'AN',
        mask: '000-000-0000||000-0000-0000'
      }, {
        code: 'AO',
        mask: '000(000)000-000'
      }, {
        code: 'AQ',
        mask: '000-000-000'
      }, {
        code: 'AR',
        mask: '00(000)000-0000'
      }, {
        code: 'AS',
        mask: '0(000)000-0000'
      }, {
        code: 'AT',
        mask: '00(000)000-0000'
      }, {
        code: 'AU',
        mask: '00-0-0000-0000'
      }, {
        code: 'AW',
        mask: '000-000-0000'
      }, {
        code: 'AZ',
        mask: '000-00-000-00-00'
      }, {
        code: 'BA',
        mask: '000-00-00000||000-00-0000'
      }, {
        code: 'BB',
        mask: '0(000)000-0000'
      }, {
        code: 'BD',
        mask: '000-00-000-000'
      }, {
        code: 'BE',
        mask: '00(000)000-000'
      }, {
        code: 'BF',
        mask: '000-00-00-0000'
      }, {
        code: 'BG',
        mask: '000(000)000-000'
      }, {
        code: 'BH',
        mask: '000-0000-0000'
      }, {
        code: 'BI',
        mask: '000-00-00-0000'
      }, {
        code: 'BJ',
        mask: '000-00-00-0000'
      }, {
        code: 'BM',
        mask: '0(000)000-0000'
      }, {
        code: 'BN',
        mask: '000-000-0000'
      }, {
        code: 'BO',
        mask: '000-0-000-0000'
      }, {
        code: 'BR',
        mask: '00(00)0000-0000||00(00)0000-0000||00(00)00000-0000'
      }, {
        code: 'BS',
        mask: '0(000)000-0000'
      }, {
        code: 'BT',
        mask: '000-00-000-000||000-0-000-000'
      }, {
        code: 'BW',
        mask: '000-00-000-000'
      }, {
        code: 'BY',
        mask: '000(00)000-00-00'
      }, {
        code: 'BZ',
        mask: '000-000-0000'
      }, {
        code: 'CA',
        mask: '0(000)000-0000'
      }, {
        code: 'CD',
        mask: '000(000)000-000'
      }, {
        code: 'CF',
        mask: '000-00-00-0000'
      }, {
        code: 'CG',
        mask: '000-00-000-0000'
      }, {
        code: 'CH',
        mask: '00-00-000-0000'
      }, {
        code: 'CI',
        mask: '000-00-000-000'
      }, {
        code: 'CK',
        mask: '000-00-000'
      }, {
        code: 'CL',
        mask: '00-0-0000-0000'
      }, {
        code: 'CM',
        mask: '000-0000-0000'
      }, {
        code: 'CN',
        mask: '00(000)0000-0000||00(000)0000-000||00-00-00000-00000'
      }, {
        code: 'CO',
        mask: '00(000)000-0000'
      }, {
        code: 'CR',
        mask: '000-0000-0000'
      }, {
        code: 'CU',
        mask: '00-0-000-0000'
      }, {
        code: 'CV',
        mask: '000(000)00-00'
      }, {
        code: 'CW',
        mask: '000-000-0000'
      }, {
        code: 'CY',
        mask: '000-00-000-000'
      }, {
        code: 'CZ',
        mask: '000(000)000-000'
      }, {
        code: 'DE',
        mask: '00(0000)000-0000||00(000)000-0000||00(000)00-0000||00(000)00-000||00(000)00-00||00-000-000'
      }, {
        code: 'DJ',
        mask: '000-00-00-00-00'
      }, {
        code: 'DK',
        mask: '00-00-00-00-00'
      }, {
        code: 'DM',
        mask: '0(000)000-0000'
      }, {
        code: 'DO',
        mask: '0(000)000-0000||0(000)000-0000||0(000)000-0000'
      }, {
        code: 'DZ',
        mask: '000-00-000-0000'
      }, {
        code: 'EC',
        mask: '000-00-000-0000||000-0-000-0000'
      }, {
        code: 'EE',
        mask: '000-0000-0000||000-000-0000'
      }, {
        code: 'EG',
        mask: '00(000)000-0000'
      }, {
        code: 'ER',
        mask: '000-0-000-000'
      }, {
        code: 'ES',
        mask: '00(000)000-000'
      }, {
        code: 'ET',
        mask: '000-00-000-0000'
      }, {
        code: 'FI',
        mask: '000(000)000-00-00'
      }, {
        code: 'FJ',
        mask: '000-00-00000'
      }, {
        code: 'FK',
        mask: '000-00000'
      }, {
        code: 'FM',
        mask: '000-000-0000'
      }, {
        code: 'FO',
        mask: '000-000-000'
      }, {
        code: 'FR',
        mask: '000-00000-0000||00(000)000-000||000-00-0000||000(000)000-000'
      }, {
        code: 'GA',
        mask: '000-0-00-00-00'
      }, {
        code: 'GD',
        mask: '0(000)000-0000'
      }, {
        code: 'GE',
        mask: '000(000)000-000'
      }, {
        code: 'GF',
        mask: '000-00000-0000'
      }, {
        code: 'GH',
        mask: '000(000)000-000'
      }, {
        code: 'GI',
        mask: '000-000-00000'
      }, {
        code: 'GL',
        mask: '000-00-00-00'
      }, {
        code: 'GM',
        mask: '000(000)00-00'
      }, {
        code: 'GN',
        mask: '000-00-000-000'
      }, {
        code: 'GQ',
        mask: '000-00-000-0000'
      }, {
        code: 'GR',
        mask: '00(000)000-0000'
      }, {
        code: 'GT',
        mask: '000-0-000-0000'
      }, {
        code: 'GU',
        mask: '0(000)000-0000'
      }, {
        code: 'GW',
        mask: '000-0-000000'
      }, {
        code: 'GY',
        mask: '000-000-0000'
      }, {
        code: 'HK',
        mask: '000-0000-0000'
      }, {
        code: 'HN',
        mask: '000-0000-0000'
      }, {
        code: 'HR',
        mask: '000-00-000-000'
      }, {
        code: 'HT',
        mask: '000-00-00-0000'
      }, {
        code: 'HU',
        mask: '00(000)000-000'
      }, {
        code: 'ID',
        mask: '00(000)000-0000'
      }, {
        code: 'ID',
        mask: '00-00-000-00'
      }, {
        code: 'ID',
        mask: '00-00-000-000'
      }, {
        code: 'ID',
        mask: '00-00-000-0000'
      }, {
        code: 'ID',
        mask: '00(000)000-000'
      }, {
        code: 'ID',
        mask: '00(000)000-00-000'
      }, {
        code: 'IE',
        mask: '000(000)000-000'
      }, {
        code: 'IL',
        mask: '000-00-000-0000'
      }, {
        code: 'IL',
        mask: '000-0-000-0000'
      }, {
        code: 'IN',
        mask: '00(0000)000-000'
      }, {
        code: 'IO',
        mask: '000-000-0000'
      }, {
        code: 'IQ',
        mask: '000(000)000-0000'
      }, {
        code: 'IR',
        mask: '00(000)000-0000'
      }, {
        code: 'IS',
        mask: '000-000-0000'
      }, {
        code: 'IT',
        mask: '00(000)0000-000'
      }, {
        code: 'JM',
        mask: '0(000)000-0000'
      }, {
        code: 'JO',
        mask: '000-0-0000-0000'
      }, {
        code: 'JP',
        mask: '00-00-0000-0000'
      }, {
        code: 'JP',
        mask: '00(000)000-000'
      }, {
        code: 'KE',
        mask: '000-000-000000'
      }, {
        code: 'KG',
        mask: '000(000)000-000'
      }, {
        code: 'KH',
        mask: '000-00-000-000'
      }, {
        code: 'KI',
        mask: '000-00-000'
      }, {
        code: 'KM',
        mask: '000-00-00000'
      }, {
        code: 'KN',
        mask: '0(000)000-0000'
      }, {
        code: 'KP',
        mask: '000-000-000-0000'
      }, {
        code: 'KP',
        mask: '000-00-000-000'
      }, {
        code: 'KP',
        mask: '000-000-0000-000'
      }, {
        code: 'KP',
        mask: '000-000-000'
      }, {
        code: 'KP',
        mask: '000-0000-0000'
      }, {
        code: 'KP',
        mask: '000-0000-0000000000000'
      }, {
        code: 'KR',
        mask: '00-00-000-0000'
      }, {
        code: 'KW',
        mask: '000-0000-0000'
      }, {
        code: 'KY',
        mask: '0(000)000-0000'
      }, {
        code: 'KZ',
        mask: '0(000)000-00-00'
      }, {
        code: 'KZ',
        mask: '0(000)000-00-00'
      }, {
        code: 'LA',
        mask: '000(0000)000-000'
      }, {
        code: 'LA',
        mask: '000-00-000-000'
      }, {
        code: 'LB',
        mask: '000-00-000-000'
      }, {
        code: 'LB',
        mask: '000-0-000-000'
      }, {
        code: 'LC',
        mask: '0(000)000-0000'
      }, {
        code: 'LI',
        mask: '000(000)000-0000'
      }, {
        code: 'LK',
        mask: '00-00-000-0000'
      }, {
        code: 'LR',
        mask: '000-00-000-000'
      }, {
        code: 'LS',
        mask: '000-0-000-0000'
      }, {
        code: 'LT',
        mask: '000(000)00-000'
      }, {
        code: 'LU',
        mask: '000(000)000-000'
      }, {
        code: 'LV',
        mask: '000-00-000-000'
      }, {
        code: 'LY',
        mask: '000-00-000-000'
      }, {
        code: 'LY',
        mask: '000-00-000-0000'
      }, {
        code: 'MA',
        mask: '000-00-0000-000'
      }, {
        code: 'MC',
        mask: '000(000)000-000'
      }, {
        code: 'MC',
        mask: '000-00-000-000'
      }, {
        code: 'MD',
        mask: '000-0000-0000'
      }, {
        code: 'ME',
        mask: '000-00-000-000'
      }, {
        code: 'MG',
        mask: '000-00-00-00000'
      }, {
        code: 'MH',
        mask: '000-000-0000'
      }, {
        code: 'MK',
        mask: '000-00-000-000'
      }, {
        code: 'ML',
        mask: '000-00-00-0000'
      }, {
        code: 'MM',
        mask: '00-00-000-000'
      }, {
        code: 'MM',
        mask: '00-0-000-000'
      }, {
        code: 'MM',
        mask: '00-000-000'
      }, {
        code: 'MN',
        mask: '000-00-00-0000'
      }, {
        code: 'MO',
        mask: '000-0000-0000'
      }, {
        code: 'MP',
        mask: '0(000)000-0000'
      }, {
        code: 'MQ',
        mask: '000(000)00-00-00'
      }, {
        code: 'MR',
        mask: '000-00-00-0000'
      }, {
        code: 'MS',
        mask: '0(000)000-0000'
      }, {
        code: 'MT',
        mask: '000-0000-0000'
      }, {
        code: 'MU',
        mask: '000-000-0000'
      }, {
        code: 'MV',
        mask: '000-000-0000'
      }, {
        code: 'MW',
        mask: '000-0-000-000'
      }, {
        code: 'MW',
        mask: '000-0-0000-0000'
      }, {
        code: 'MX',
        mask: '00(000)000-0000'
      }, {
        code: 'MX',
        mask: '00-00-00-0000'
      }, {
        code: 'MY',
        mask: '00-00-000-0000'
      }, {
        code: 'MY',
        mask: '00(000)000-000'
      }, {
        code: 'MY',
        mask: '00-00-000-000'
      }, {
        code: 'MY',
        mask: '00-0-000-000'
      }, {
        code: 'MZ',
        mask: '000-00-000-000'
      }, {
        code: 'NA',
        mask: '000-00-000-0000'
      }, {
        code: 'NC',
        mask: '000-00-0000'
      }, {
        code: 'NE',
        mask: '000-00-00-0000'
      }, {
        code: 'NF',
        mask: '000-000-000'
      }, {
        code: 'NG',
        mask: '000(000)000-0000'
      }, {
        code: 'NG',
        mask: '000-00-000-000'
      }, {
        code: 'NG',
        mask: '000-00-000-00'
      }, {
        code: 'NG',
        mask: '000(000)000-0000'
      }, {
        code: 'NI',
        mask: '000-0000-0000'
      }, {
        code: 'NL',
        mask: '00-00-000-0000'
      }, {
        code: 'NO',
        mask: '00(000)00-000'
      }, {
        code: 'NP',
        mask: '000-00-000-000'
      }, {
        code: 'NR',
        mask: '000-000-0000'
      }, {
        code: 'NU',
        mask: '000-0000'
      }, {
        code: 'NZ',
        mask: '00(000)000-000'
      }, {
        code: 'NZ',
        mask: '00-00-000-000'
      }, {
        code: 'NZ',
        mask: '00(000)000-0000'
      }, {
        code: 'OM',
        mask: '000-00-000-000'
      }, {
        code: 'PA',
        mask: '000-000-0000'
      }, {
        code: 'PE',
        mask: '00(000)000-000'
      }, {
        code: 'PF',
        mask: '000-00-00-00'
      }, {
        code: 'PG',
        mask: '000(000)00-000'
      }, {
        code: 'PH',
        mask: '00(000)000-0000'
      }, {
        code: 'PK',
        mask: '00(000)000-0000'
      }, {
        code: 'PL',
        mask: '00(000)000-000'
      }, {
        code: 'PS',
        mask: '000-00-000-0000'
      }, {
        code: 'PT',
        mask: '000-00-000-0000'
      }, {
        code: 'PW',
        mask: '000-000-0000'
      }, {
        code: 'PY',
        mask: '000(000)000-000'
      }, {
        code: 'QA',
        mask: '000-0000-0000'
      }, {
        code: 'RE',
        mask: '000-00000-0000'
      }, {
        code: 'RO',
        mask: '00-00-000-0000'
      }, {
        code: 'RS',
        mask: '000-00-000-0000'
      }, {
        code: 'RU',
        mask: '0(000)000-00-00'
      }, {
        code: 'RW',
        mask: '000(000)000-000'
      }, {
        code: 'SA',
        mask: '000-0-0000-0000'
      }, {
        code: 'SA',
        mask: '000-0-000-0000'
      }, {
        code: 'SB',
        mask: '000-000-0000'
      }, {
        code: 'SB',
        mask: '000-00000'
      }, {
        code: 'SC',
        mask: '000-0-000-000'
      }, {
        code: 'SD',
        mask: '000-00-000-0000'
      }, {
        code: 'SE',
        mask: '00-00-000-0000'
      }, {
        code: 'SG',
        mask: '00-0000-0000'
      }, {
        code: 'SH',
        mask: '000-0000'
      }, {
        code: 'SH',
        mask: '000-0000'
      }, {
        code: 'SI',
        mask: '000-00-000-000'
      }, {
        code: 'SK',
        mask: '000(000)000-000'
      }, {
        code: 'SL',
        mask: '000-00-000000'
      }, {
        code: 'SM',
        mask: '000-0000-000000'
      }, {
        code: 'SN',
        mask: '000-00-000-0000'
      }, {
        code: 'SO',
        mask: '000-00-000-000'
      }, {
        code: 'SO',
        mask: '000-0-000-000'
      }, {
        code: 'SO',
        mask: '000-0-000-000'
      }, {
        code: 'SR',
        mask: '000-000-0000'
      }, {
        code: 'SR',
        mask: '000-000-000'
      }, {
        code: 'SS',
        mask: '000-00-000-0000'
      }, {
        code: 'ST',
        mask: '000-00-00000'
      }, {
        code: 'SV',
        mask: '000-00-00-0000'
      }, {
        code: 'SX',
        mask: '0(000)000-0000'
      }, {
        code: 'SY',
        mask: '000-00-0000-000'
      }, {
        code: 'SZ',
        mask: '000-00-00-0000'
      }, {
        code: 'TC',
        mask: '0(000)000-0000'
      }, {
        code: 'TD',
        mask: '000-00-00-00-00'
      }, {
        code: 'TG',
        mask: '000-00-000-000'
      }, {
        code: 'TH',
        mask: '00-00-000-0000'
      }, {
        code: 'TH',
        mask: '00-00-000-000'
      }, {
        code: 'TJ',
        mask: '000-00-000-0000'
      }, {
        code: 'TK',
        mask: '000-0000'
      }, {
        code: 'TL',
        mask: '000-000-0000'
      }, {
        code: 'TL',
        mask: '000-000-00000'
      }, {
        code: 'TL',
        mask: '000-000-00000'
      }, {
        code: 'TM',
        mask: '000-0-000-0000'
      }, {
        code: 'TN',
        mask: '000-00-000-000'
      }, {
        code: 'TO',
        mask: '000-00000'
      }, {
        code: 'TR',
        mask: '00(000)000-0000'
      }, {
        code: 'TT',
        mask: '0(000)000-0000'
      }, {
        code: 'TV',
        mask: '000-000000'
      }, {
        code: 'TV',
        mask: '000-00000'
      }, {
        code: 'TW',
        mask: '000-0-0000-0000'
      }, {
        code: 'TW',
        mask: '000-0000-0000'
      }, {
        code: 'TZ',
        mask: '000-00-000-0000'
      }, {
        code: 'UA',
        mask: '000(00)000-00-00'
      }, {
        code: 'UG',
        mask: '000(000)000-000'
      }, {
        code: 'UK',
        mask: '00-00-0000-0000'
      }, {
        code: 'US',
        mask: '0(000)000-0000'
      }, {
        code: 'UY',
        mask: '000-0-000-00-00'
      }, {
        code: 'UZ',
        mask: '000-00-000-0000'
      }, {
        code: 'VA',
        mask: '00-0-000-00000'
      }, {
        code: 'VC',
        mask: '0(000)000-0000'
      }, {
        code: 'VE',
        mask: '00(000)000-0000'
      }, {
        code: 'VG',
        mask: '0(000)000-0000'
      }, {
        code: 'VI',
        mask: '0(000)000-0000'
      }, {
        code: 'VN',
        mask: '00-00-0000-000'
      }, {
        code: 'VN',
        mask: '00(000)0000-000'
      }, {
        code: 'VU',
        mask: '000-00-00000'
      }, {
        code: 'VU',
        mask: '000-00000'
      }, {
        code: 'WF',
        mask: '000-00-0000'
      }, {
        code: 'WS',
        mask: '000-00-0000'
      }, {
        code: 'YE',
        mask: '000-000-000-000'
      }, {
        code: 'YE',
        mask: '000-0-000-000'
      }, {
        code: 'YE',
        mask: '000-00-000-000'
      }, {
        code: 'ZA',
        mask: '00-00-000-0000'
      }, {
        code: 'ZM',
        mask: '000-00-000-0000'
      }, {
        code: 'ZW',
        mask: '000-0-000000'
      }];
    }
    static {
      this.ɵfac = function CountryPhoneMask_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CountryPhoneMask)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CountryPhoneMask,
        factory: CountryPhoneMask.ɵfac
      });
    }
  }
  return CountryPhoneMask;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var SearchCountryField = /*#__PURE__*/function (SearchCountryField) {
  SearchCountryField["DialCode"] = "dialCode";
  SearchCountryField["Iso2"] = "iso2";
  SearchCountryField["Name"] = "name";
  SearchCountryField["All"] = "all";
  return SearchCountryField;
}(SearchCountryField || {});
var PhoneNumberFormat = /*#__PURE__*/function (PhoneNumberFormat) {
  PhoneNumberFormat["International"] = "INTERNATIONAL";
  PhoneNumberFormat["National"] = "NATIONAL";
  return PhoneNumberFormat;
}(PhoneNumberFormat || {});
/*
We use "control: any" instead of "control: FormControl" to silence:
"Property 'nativeElement' does not exist on type 'FormControl'".
This happens because I've expanded control with nativeElement via
'NativeElementInjectorDirective' to get an access to the element.
More about this approach and reasons for this:
https://github.com/angular/angular/issues/18025
https://stackoverflow.com/a/54075119/1617590
*/
const phoneNumberValidator = control => {
  if (!control.value) {
    return;
  }
  // Find <input> inside injected nativeElement and get its "id".
  const el = control.nativeElement;
  const inputBox = el ? el.querySelector('input[type="tel"]') : undefined;
  if (inputBox) {
    const id = inputBox.id;
    const isCheckValidation = inputBox.getAttribute('validation');
    if (isCheckValidation === 'true') {
      const isRequired = control.errors && control.errors.required === true;
      const error = {
        validatePhoneNumber: {
          valid: false
        }
      };
      inputBox.setCustomValidity('Invalid field.');
      let number;
      try {
        number = lpn.PhoneNumberUtil.getInstance().parse(control.value.number, control.value.countryCode);
      } catch (e) {
        if (isRequired) {
          return error;
        } else {
          inputBox.setCustomValidity('');
        }
      }
      if (control.value) {
        // @ts-ignore
        if (!number) {
          return error;
        } else {
          if (!lpn.PhoneNumberUtil.getInstance().isValidNumberForRegion(number, control.value.countryCode)) {
            return error;
          } else {
            inputBox.setCustomValidity('');
          }
        }
      }
    } else if (isCheckValidation === 'false') {
      inputBox.setCustomValidity('');
      control.clearValidators();
    }
  }
  return;
};

/*
"Property 'nativeElement' does not exist on type 'FormControl'".
'NativeElementInjectorDirective' injects nativeElement to each control,
so we can access it from inside validator for example.
More about this approach and reasons for this:
https://github.com/angular/angular/issues/18025
https://stackoverflow.com/a/54075119/1617590
*/
let NativeElementInjectorDirective = /*#__PURE__*/(() => {
  class NativeElementInjectorDirective {
    constructor(controlDir, host) {
      this.controlDir = controlDir;
      this.host = host;
    }
    ngOnInit() {
      if (this.controlDir.control) {
        // @ts-ignore
        this.controlDir.control['nativeElement'] = this.host.nativeElement;
      }
    }
    static {
      this.ɵfac = function NativeElementInjectorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NativeElementInjectorDirective)(i0.ɵɵdirectiveInject(i4.NgControl), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NativeElementInjectorDirective,
        selectors: [["", "ngModel", ""], ["", "formControl", ""], ["", "formControlName", ""]]
      });
    }
  }
  return NativeElementInjectorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxIntlPhoneInputComponent = /*#__PURE__*/(() => {
  class NgxIntlPhoneInputComponent {
    constructor(countryCodeData, countryPhoneMask) {
      this.countryCodeData = countryCodeData;
      this.countryPhoneMask = countryPhoneMask;
      this.value = '';
      this.preferredCountries = [];
      this.enablePlaceholder = true;
      this.numberFormat = PhoneNumberFormat.International;
      this.cssClass = 'form-control';
      this.onlyCountries = [];
      this.enableAutoCountrySelect = true;
      this.searchCountryFlag = false;
      this.searchCountryField = [SearchCountryField.All];
      this.searchCountryPlaceholder = 'Search Country';
      this.selectFirstCountry = true;
      this.phoneValidation = false;
      this.inputId = 'phone';
      this.separateDialCode = false;
      this.includeDialCode = false;
      this.useMask = false;
      this.showMaskTyped = false;
      this.exclusionarySearch = false;
      this.localization = 'en';
      this.countryChange = new EventEmitter();
      this.mask$ = new BehaviorSubject('');
      this.selectedCountry = {
        areaCodes: undefined,
        dialCode: '',
        htmlId: '',
        flagClass: '',
        iso2: '',
        name: '',
        placeHolder: '',
        priority: 0
      };
      this.phoneNumber = '';
      this.allCountries = [];
      this.allTempCountries = [];
      this.preferredCountriesInDropDown = [];
      // Has to be 'any' to prevent a need to install @types/google-libphonenumber by the package user...
      this.phoneUtil = lpn.PhoneNumberUtil.getInstance();
      this.disabled = false;
      this.errors = ['Phone number is required.'];
      this.countrySearchText = '';
      this.includedCountryCode = '';
      this.onTouched = () => {};
      this.propagateChange = _ => {};
      // If this is not set, ngx-bootstrap will try to use the bs3 CSS (which is not what we've embedded) and will
      // Add the wrong classes and such
      setTheme('bs4');
    }
    ngOnInit() {
      this.init();
    }
    ngOnChanges(changes) {
      const selectedISO = changes['selectedCountryISO'];
      if (this.allCountries && selectedISO && selectedISO.currentValue !== selectedISO.previousValue) {
        this.updateSelectedCountry();
      }
      if (changes['preferredCountries']) {
        this.updatePreferredCountries();
      }
      this.checkSeparateDialCodeStyle();
    }
    /*
        This is a wrapper method to avoid calling this.ngOnInit() in writeValue().
        Ref: http://codelyzer.com/rules/no-life-cycle-call/
    */
    init() {
      this.fetchCountryData();
      if (this.preferredCountries.length) {
        this.updatePreferredCountries();
      }
      if (this.onlyCountries.length) {
        this.allCountries = this.allCountries.filter(c => this.onlyCountries.includes(c.iso2));
      }
      if (this.selectFirstCountry) {
        if (this.preferredCountriesInDropDown.length) {
          this.setSelectedCountry(this.preferredCountriesInDropDown[0]);
        } else {
          this.setSelectedCountry(this.allCountries[0]);
        }
      }
      this.updateSelectedCountry();
      this.checkSeparateDialCodeStyle();
    }
    setSelectedCountry(country) {
      this.selectedCountry = country;
      this.includeCountryCodeToInput(country);
    }
    includeCountryCodeToInput(country) {
      if (this.includeDialCode) {
        if (this.includedCountryCode.length > 0) {
          this.phoneNumber = this.phoneNumber.replace(this.includedCountryCode, '');
        }
        this.includedCountryCode = country.dialCode;
        this.phoneNumber = `${this.includedCountryCode}${this.phoneNumber}`;
        const input = document.getElementById(this.inputId);
        setTimeout(() => {
          this.setCaretPosition(input, this.includedCountryCode.length + 1);
        }, 0);
        this.onPhoneNumberChange();
        this.countryChange.emit(country);
      } else {
        this.countryChange.emit(country);
      }
    }
    setCaretPosition(ctrl, pos) {
      if (ctrl.setSelectionRange) {
        ctrl.focus();
        ctrl.setSelectionRange(pos, pos);
      } else if (ctrl.createTextRange) {
        var range = ctrl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
      }
    }
    /**
     * Search country based on country name, iso2, dialCode or all of them.
     */
    searchCountry() {
      if (!this.countrySearchText) {
        this.countryList.nativeElement.querySelector('.iti__country-list li').scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
        return;
      }
      const countrySearchTextLower = this.countrySearchText.toLowerCase();
      // @ts-ignore
      const country = this.allCountries.filter(c => {
        if (this.searchCountryField.indexOf(SearchCountryField.All) > -1) {
          // Search in all fields
          if (c.iso2.toLowerCase().startsWith(countrySearchTextLower)) {
            return c;
          }
          if (c.name.toLowerCase().startsWith(countrySearchTextLower)) {
            return c;
          }
          if (c.dialCode.startsWith(this.countrySearchText)) {
            return c;
          }
        } else {
          // Or search by specific SearchCountryField(s)
          if (this.searchCountryField.indexOf(SearchCountryField.Iso2) > -1) {
            if (c.iso2.toLowerCase().startsWith(countrySearchTextLower)) {
              return c;
            }
          }
          if (this.searchCountryField.indexOf(SearchCountryField.Name) > -1) {
            if (c.name.toLowerCase().startsWith(countrySearchTextLower)) {
              return c;
            }
          }
          if (this.searchCountryField.indexOf(SearchCountryField.DialCode) > -1) {
            if (c.dialCode.startsWith(this.countrySearchText)) {
              return c;
            }
          }
        }
      });
      if (this.exclusionarySearch) {
        this.allTempCountries = country;
        return;
      }
      if (country.length > 0) {
        const el = this.countryList.nativeElement.querySelector('#' + country[0].htmlId);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }
      this.checkSeparateDialCodeStyle();
    }
    get getAllCountries() {
      if (this.countrySearchText.length) {
        if (this.exclusionarySearch) {
          return this.allTempCountries;
        } else {
          return this.allCountries;
        }
      } else {
        return this.allCountries;
      }
    }
    onPhoneNumberChange() {
      let countryCode;
      // Handle the case where the user sets the value programatically based on a persisted ChangeData obj.
      if (this.phoneNumber && typeof this.phoneNumber === 'object') {
        const numberObj = this.phoneNumber;
        this.phoneNumber = numberObj.number?.startsWith('+') ? numberObj.number : '+' + numberObj.number;
        countryCode = numberObj.countryCode;
      }
      if (this.phoneNumber && !this.phoneNumber?.startsWith('+')) {
        this.phoneNumber = '+' + this.phoneNumber;
      }
      this.value = this.phoneNumber;
      countryCode = countryCode || this.selectedCountry.iso2;
      // @ts-ignore
      const number = this.getParsedNumber(this.phoneNumber, countryCode);
      // auto select country based on the extension (and areaCode if needed) (e.g select Canada if number starts with +1 416)
      if (this.enableAutoCountrySelect) {
        if (this.value === '') {
          this.selectedCountry = {
            areaCodes: undefined,
            dialCode: '',
            htmlId: '',
            flagClass: '',
            iso2: '',
            name: '',
            placeHolder: '',
            priority: 0
          };
        }
        countryCode = number && number.getCountryCode()
        // @ts-ignore
        ? this.getCountryIsoCode(number.getCountryCode(), number) : this.selectedCountry.iso2;
        if (countryCode && countryCode !== this.selectedCountry.iso2) {
          const newCountry = this.allCountries.sort((a, b) => {
            return a.priority - b.priority;
          }).find(c => c.iso2 === countryCode);
          if (newCountry) {
            this.selectedCountry = newCountry;
          }
        }
      }
      countryCode = countryCode ? countryCode : this.selectedCountry.iso2;
      this.checkSeparateDialCodeStyle();
      if (!this.value) {
        // Reason: avoid https://stackoverflow.com/a/54358133/1617590
        // tslint:disable-next-line: no-null-keyword
        // @ts-ignore
        this.propagateChange(null);
      } else {
        const intlNo = number ? this.phoneUtil.format(number, lpn.PhoneNumberFormat.INTERNATIONAL) : '';
        // parse phoneNumber if separate dial code is needed
        if (this.separateDialCode && intlNo) {
          this.value = this.removeDialCode(intlNo);
        }
        this.propagateChange({
          number: this.value,
          internationalNumber: intlNo,
          nationalNumber: number ? this.phoneUtil.format(number, lpn.PhoneNumberFormat.NATIONAL) : '',
          e164Number: number ? this.phoneUtil.format(number, lpn.PhoneNumberFormat.E164) : '',
          countryCode: countryCode.toUpperCase(),
          dialCode: '+' + this.selectedCountry.dialCode
        });
      }
    }
    onCountrySelect(country, el) {
      this.setSelectedCountry(country);
      this.checkSeparateDialCodeStyle();
      if (this.phoneNumber && this.phoneNumber.length > 0) {
        this.value = this.phoneNumber;
        const number = this.getParsedNumber(this.phoneNumber, this.selectedCountry.iso2);
        const intlNo = number ? this.phoneUtil.format(number, lpn.PhoneNumberFormat.INTERNATIONAL) : '';
        // parse phoneNumber if separate dial code is needed
        if (this.separateDialCode && intlNo) {
          this.value = this.removeDialCode(intlNo);
        }
        this.propagateChange({
          number: this.value,
          internationalNumber: intlNo,
          nationalNumber: number ? this.phoneUtil.format(number, lpn.PhoneNumberFormat.NATIONAL) : '',
          e164Number: number ? this.phoneUtil.format(number, lpn.PhoneNumberFormat.E164) : '',
          countryCode: this.selectedCountry.iso2.toUpperCase(),
          dialCode: '+' + this.selectedCountry.dialCode
        });
      } else {
        // Reason: avoid https://stackoverflow.com/a/54358133/1617590
        // tslint:disable-next-line: no-null-keyword
        // @ts-ignore
        this.propagateChange(null);
      }
      el.focus();
    }
    onInputKeyPress(event) {
      const allowedChars = /[0-9\+\-\(\)\ ]/;
      const allowedCtrlChars = /[axcv]/; // Allows copy-pasting
      const allowedOtherKeys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End', 'Insert', 'Delete', 'Backspace'];
      if (!allowedChars.test(event.key) && !(event.ctrlKey && allowedCtrlChars.test(event.key)) && !allowedOtherKeys.includes(event.key)) {
        event.preventDefault();
      }
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    writeValue(obj) {
      if (obj === undefined) {
        this.init();
      }
      this.phoneNumber = obj;
      setTimeout(() => {
        this.onPhoneNumberChange();
      }, 1);
    }
    resolvePlaceholder() {
      let placeholder = '';
      if (this.customPlaceholder) {
        placeholder = this.customPlaceholder;
      } else if (this.selectedCountry.placeHolder) {
        placeholder = this.selectedCountry.placeHolder;
        if (this.separateDialCode) {
          placeholder = this.removeDialCode(placeholder);
        }
      }
      return placeholder;
    }
    /* --------------------------------- Helpers -------------------------------- */
    /**
     * Returns parse PhoneNumber object.
     * @param phoneNumber string
     * @param countryCode string
     */
    getParsedNumber(phoneNumber, countryCode) {
      let number;
      try {
        number = this.phoneUtil.parse(phoneNumber, countryCode.toUpperCase());
      } catch (e) {}
      // @ts-ignore
      return number;
    }
    /**
     * Adjusts input alignment based on the dial code presentation style.
     */
    checkSeparateDialCodeStyle() {
      if (this.separateDialCode && this.selectedCountry) {
        const cntryCd = this.selectedCountry.dialCode;
        this.separateDialCodeClass = 'separate-dial-code iti-sdc-' + (cntryCd.length + 1);
      } else {
        this.separateDialCodeClass = '';
      }
    }
    /**
     * Cleans dialcode from phone number string.
     * @param phoneNumber string
     */
    removeDialCode(phoneNumber) {
      const number = this.getParsedNumber(phoneNumber, this.selectedCountry.iso2);
      phoneNumber = this.phoneUtil.format(number, lpn.PhoneNumberFormat[this.numberFormat]);
      if (phoneNumber.startsWith('+') && this.separateDialCode) {
        phoneNumber = phoneNumber.substr(phoneNumber.indexOf(' ') + 1);
      }
      return phoneNumber;
    }
    /**
     * Sifts through all countries and returns iso code of the primary country
     * based on the number provided.
     * @param countryCode country code in number format
     * @param number PhoneNumber object
     */
    getCountryIsoCode(countryCode, number) {
      // Will use this to match area code from the first numbers
      // @ts-ignore
      const rawNumber = number['values_']['2'].toString();
      // List of all countries with countryCode (can be more than one. e.x. US, CA, DO, PR all have +1 countryCode)
      const countries = this.allCountries.filter(c => c.dialCode === countryCode.toString());
      // Main country is the country, which has no areaCodes specified in country-code.ts file.
      const mainCountry = countries.find(c => c.areaCodes === undefined);
      // Secondary countries are all countries, which have areaCodes specified in country-code.ts file.
      const secondaryCountries = countries.filter(c => c.areaCodes !== undefined);
      let matchedCountry = mainCountry ? mainCountry.iso2 : undefined;
      /*
          Iterate over each secondary country and check if nationalNumber starts with any of areaCodes available.
          If no matches found, fallback to the main country.
      */
      secondaryCountries.forEach(country => {
        // @ts-ignore
        country.areaCodes.forEach(areaCode => {
          if (rawNumber.startsWith(areaCode)) {
            matchedCountry = country.iso2;
          }
        });
      });
      return matchedCountry;
    }
    /**
     * Gets formatted example phone number from phoneUtil.
     * @param countryCode string
     */
    getPhoneNumberPlaceHolder(countryCode) {
      try {
        return this.phoneUtil.format(this.phoneUtil.getExampleNumber(countryCode), lpn.PhoneNumberFormat[this.numberFormat]);
      } catch (e) {
        // @ts-ignore
        return e;
      }
    }
    fetchCountryData() {
      this.allCountries = [];
      this.countryCodeData.allCountries[this.localization].forEach(c => {
        const country = {
          name: c[0].toString(),
          iso2: c[1].toString(),
          dialCode: c[2].toString(),
          priority: +c[3] || 0,
          areaCodes: c[4] || undefined,
          htmlId: `iti-0__item-${c[1].toString()}`,
          flagClass: `iti__${c[1].toString().toLocaleLowerCase()}`,
          placeHolder: ''
        };
        if (this.enablePlaceholder) {
          country.placeHolder = this.getPhoneNumberPlaceHolder(country.iso2.toUpperCase());
        }
        this.allCountries.push(country);
      });
    }
    /**
     * Populates preferredCountriesInDropDown with prefferred countries.
     */
    updatePreferredCountries() {
      if (this.preferredCountries.length) {
        this.preferredCountriesInDropDown = [];
        this.preferredCountries.forEach(iso2 => {
          const preferredCountry = this.allCountries.filter(c => {
            return c.iso2 === iso2;
          });
          this.preferredCountriesInDropDown.push(preferredCountry[0]);
        });
      }
    }
    /**
     * Updates selectedCountry.
     */
    updateSelectedCountry() {
      if (this.selectedCountryISO) {
        // @ts-ignore
        this.selectedCountry = this.allCountries.find(c => {
          return c.iso2.toLowerCase() === this.selectedCountryISO.toLowerCase();
        });
        if (this.selectedCountry) {
          if (this.phoneNumber) {
            this.onPhoneNumberChange();
          } else {
            // Reason: avoid https://stackoverflow.com/a/54358133/1617590
            // tslint:disable-next-line: no-null-keyword
            // @ts-ignore
            this.propagateChange(null);
          }
        }
      }
    }
    generateMask(countryCode) {
      if (countryCode) {
        return this.countryPhoneMask.countryPhoneMask.find(mask => mask.code === countryCode.toUpperCase())?.mask;
      } else {
        return '0000000000000';
      }
    }
    static {
      this.ɵfac = function NgxIntlPhoneInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxIntlPhoneInputComponent)(i0.ɵɵdirectiveInject(CountryCode), i0.ɵɵdirectiveInject(CountryPhoneMask));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxIntlPhoneInputComponent,
        selectors: [["ngx-intl-phone-input"]],
        viewQuery: function NgxIntlPhoneInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.countryList = _t.first);
          }
        },
        inputs: {
          value: "value",
          preferredCountries: "preferredCountries",
          enablePlaceholder: "enablePlaceholder",
          customPlaceholder: "customPlaceholder",
          numberFormat: "numberFormat",
          cssClass: "cssClass",
          onlyCountries: "onlyCountries",
          enableAutoCountrySelect: "enableAutoCountrySelect",
          searchCountryFlag: "searchCountryFlag",
          searchCountryField: "searchCountryField",
          searchCountryPlaceholder: "searchCountryPlaceholder",
          maxLength: "maxLength",
          selectFirstCountry: "selectFirstCountry",
          selectedCountryISO: "selectedCountryISO",
          phoneValidation: "phoneValidation",
          inputId: "inputId",
          separateDialCode: "separateDialCode",
          includeDialCode: "includeDialCode",
          useMask: "useMask",
          showMaskTyped: "showMaskTyped",
          exclusionarySearch: "exclusionarySearch",
          localization: "localization"
        },
        outputs: {
          countryChange: "countryChange"
        },
        features: [i0.ɵɵProvidersFeature([CountryCode, CountryPhoneMask, {
          provide: NG_VALUE_ACCESSOR,
          // tslint:disable-next-line:no-forward-ref
          useExisting: forwardRef(() => NgxIntlPhoneInputComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useValue: phoneNumberValidator,
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 9,
        vars: 18,
        consts: [["focusable", ""], ["countryList", ""], [1, "iti", "iti--allow-dropdown", 3, "ngClass"], ["dropdown", "", 1, "iti__flag-container", 3, "ngClass", "isDisabled"], ["dropdownToggle", "", 1, "iti__selected-flag", "dropdown-toggle"], [1, "iti__flag", 3, "ngClass"], ["class", "selected-dial-code", 4, "ngIf"], [1, "iti__arrow"], ["class", "dropdown-menu country-dropdown", 4, "dropdownMenu"], ["type", "tel", "autocomplete", "off", 3, "blur", "keydown", "ngModelChange", "id", "ngClass", "ngModel", "disabled", "placeholder", "mask", "prefix", "showMaskTyped", "dropSpecialCharacters"], [1, "selected-dial-code"], [1, "dropdown-menu", "country-dropdown"], ["class", "search-container", 4, "ngIf"], [1, "iti__country-list"], ["class", "iti__country iti__preferred", 3, "id", "click", 4, "ngFor", "ngForOf"], ["class", "iti__divider", 4, "ngIf"], ["class", "iti__country iti__standard\u201C", 3, "id", "click", 4, "ngFor", "ngForOf"], [1, "search-container"], ["id", "country-search-box", "autofocus", "", 3, "ngModelChange", "keyup", "click", "ngModel", "placeholder"], [1, "iti__country", "iti__preferred", 3, "click", "id"], [1, "iti__flag-box"], ["class\u201C", "iti__flag", 3, "ngClass"], [1, "iti__country-name"], [1, "iti__dial-code"], [1, "iti__divider"], [1, "iti__country", "iti__standard\u201C", 3, "click", "id"]],
        template: function NgxIntlPhoneInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
            i0.ɵɵelement(3, "div", 5);
            i0.ɵɵtemplate(4, NgxIntlPhoneInputComponent_div_4_Template, 2, 1, "div", 6);
            i0.ɵɵelement(5, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, NgxIntlPhoneInputComponent_div_6_Template, 7, 4, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "input", 9, 0);
            i0.ɵɵlistener("blur", function NgxIntlPhoneInputComponent_Template_input_blur_7_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTouched());
            })("keydown", function NgxIntlPhoneInputComponent_Template_input_keydown_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputKeyPress($event));
            });
            i0.ɵɵtwoWayListener("ngModelChange", function NgxIntlPhoneInputComponent_Template_input_ngModelChange_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.phoneNumber, $event) || (ctx.phoneNumber = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function NgxIntlPhoneInputComponent_Template_input_ngModelChange_7_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPhoneNumberChange());
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.separateDialCodeClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c1, ctx.disabled))("isDisabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.selectedCountry.flagClass || "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.separateDialCode);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("id", ctx.inputId)("ngClass", ctx.cssClass);
            i0.ɵɵtwoWayProperty("ngModel", ctx.phoneNumber);
            i0.ɵɵproperty("disabled", ctx.disabled)("placeholder", ctx.resolvePlaceholder())("mask", ctx.generateMask(ctx.selectedCountry.iso2))("prefix", "+")("showMaskTyped", ctx.showMaskTyped)("dropSpecialCharacters", false);
            i0.ɵɵattribute("maxLength", ctx.maxLength)("validation", ctx.phoneValidation);
          }
        },
        dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i5.BsDropdownMenuDirective, i5.BsDropdownToggleDirective, i5.BsDropdownDirective, i6.NgxMaskDirective, NativeElementInjectorDirective],
        styles: [".dropup[_ngcontent-%COMP%], .dropright[_ngcontent-%COMP%], .dropdown[_ngcontent-%COMP%], .dropleft[_ngcontent-%COMP%]{position:relative}.dropdown-toggle[_ngcontent-%COMP%]{white-space:nowrap}.dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropdown-menu[_ngcontent-%COMP%]{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-right[_ngcontent-%COMP%]{right:0;left:auto}@media (min-width: 576px){.dropdown-menu-sm-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-sm-right[_ngcontent-%COMP%]{right:0;left:auto}}@media (min-width: 768px){.dropdown-menu-md-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-md-right[_ngcontent-%COMP%]{right:0;left:auto}}@media (min-width: 992px){.dropdown-menu-lg-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-lg-right[_ngcontent-%COMP%]{right:0;left:auto}}@media (min-width: 1200px){.dropdown-menu-xl-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-xl-right[_ngcontent-%COMP%]{right:0;left:auto}}.dropup[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropright[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropright[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{vertical-align:0}.dropleft[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:before{vertical-align:0}.dropdown-menu[x-placement^=top][_ngcontent-%COMP%], .dropdown-menu[x-placement^=right][_ngcontent-%COMP%], .dropdown-menu[x-placement^=bottom][_ngcontent-%COMP%], .dropdown-menu[x-placement^=left][_ngcontent-%COMP%]{right:auto;bottom:auto}.dropdown-divider[_ngcontent-%COMP%]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item[_ngcontent-%COMP%]{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active[_ngcontent-%COMP%], .dropdown-item[_ngcontent-%COMP%]:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled[_ngcontent-%COMP%], .dropdown-item[_ngcontent-%COMP%]:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.dropdown-menu.show[_ngcontent-%COMP%]{display:block}.dropdown-header[_ngcontent-%COMP%]{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[_ngcontent-%COMP%]{display:block;padding:.25rem 1.5rem;color:#212529}", "li.iti__country[_ngcontent-%COMP%]:hover{background-color:#0000000d}.iti__selected-flag.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.iti__flag-container.disabled[_ngcontent-%COMP%]{cursor:default!important}.iti.iti--allow-dropdown[_ngcontent-%COMP%]   .flag-container.disabled[_ngcontent-%COMP%]:hover   .iti__selected-flag[_ngcontent-%COMP%]{background:none}.country-dropdown[_ngcontent-%COMP%]{border:1px solid #ccc;width:fit-content;padding:1px;border-collapse:collapse}.search-container[_ngcontent-%COMP%]{position:relative}.search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;border:none;border-bottom:1px solid #ccc;padding-left:10px}.search-icon[_ngcontent-%COMP%]{position:absolute;z-index:2;width:25px;margin:1px 10px}.iti__country-list[_ngcontent-%COMP%]{position:relative;border:none}.iti[_ngcontent-%COMP%]   input#country-search-box[_ngcontent-%COMP%]{padding-left:6px}.iti[_ngcontent-%COMP%]   .selected-dial-code[_ngcontent-%COMP%]{margin-left:6px}.iti.separate-dial-code[_ngcontent-%COMP%]   .iti__selected-flag[_ngcontent-%COMP%], .iti.separate-dial-code.iti--allow-dropdown.iti-sdc-2[_ngcontent-%COMP%]   .iti__selected-flag[_ngcontent-%COMP%], .iti.separate-dial-code.iti--allow-dropdown.iti-sdc-3[_ngcontent-%COMP%]   .iti__selected-flag[_ngcontent-%COMP%], .iti.separate-dial-code.iti--allow-dropdown.iti-sdc-4[_ngcontent-%COMP%]   .iti__selected-flag[_ngcontent-%COMP%]{width:93px}.iti.separate-dial-code[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .iti.separate-dial-code.iti--allow-dropdown.iti-sdc-2[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .iti.separate-dial-code.iti--allow-dropdown.iti-sdc-3[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .iti.separate-dial-code.iti--allow-dropdown.iti-sdc-4[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{padding-left:98px}"]
      });
    }
  }
  return NgxIntlPhoneInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const dropdownModuleForRoot = BsDropdownModule.forRoot();
let NgxIntlPhoneInputModule = /*#__PURE__*/(() => {
  class NgxIntlPhoneInputModule {
    static {
      this.ɵfac = function NgxIntlPhoneInputModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxIntlPhoneInputModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxIntlPhoneInputModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask()],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, dropdownModuleForRoot]
      });
    }
  }
  return NgxIntlPhoneInputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-intl-phone-input
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CountryISO, NativeElementInjectorDirective, NgxIntlPhoneInputComponent, NgxIntlPhoneInputModule, PhoneNumberFormat, SearchCountryField, dropdownModuleForRoot };
